var Request = require('../helper/request');

function TagAssignment(app, branchId){
  var self = this;
  self.request = new Request(app);
  self.app = app;

  self.routes = {
    index: {
      url: '/branch/'+ branchId +'/tag_assignment',
      method: 'GET'
    }
  };
}

TagAssignment.prototype.index = function(){
  var self = this;
  return self.request.get(self.routes.index.url);
}

module.exports = TagAssignment;
